import { Component, OnInit, ViewContainerRef } from '@angular/core';
import {CarouselComponent} from "angular2-carousel";
import htmlDocx from 'html-docx-js/dist/html-docx';
import { LabeledProductService } from '../../../labeledproducts/services/labeledproduct.service';
import { LabeledProductShopStockService } from '../../../labeledproducts/services/labeledproductshopstock.service';
import { ProductService } from '../../../products/services/product.service';
import { SaleProductService } from '../../../sales/services/sale-product.service';
import { SaleService } from '../../../sales/services/sale.service';
import { SaleReturnService } from '../../../salesreturn/services/sale-return.service';
import { PersonService } from '../../../person/services/person.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { InvoiceService } from '../../../common/services/invoice.service';
import { CounterService } from '../../../common/services/counter.service';
import { OrderService } from '../../../common/services/order.service';
import { OrderProductService } from '../../../common/services/orderproduct.service';
import { CounterSettings } from '../../../api.settings';
import { ShopService } from '../../../configuration/services/shop.service';
import { UserService } from '../../../common/services/user.service';

import { RepurchaseService } from '../../../repurchase/services/repurchase.service';
import { RepurchaseRenewalService } from '../../../repurchase/services/repurchase-renewal.service';
import { TechnicalserviceService } from '../../../technicalservice/services/technicalservice.service';
import { PurchaseService } from '../../../purchase/services/purchase.service';
import { ExpensesService } from '../../../expenses/services/expenses.service';
import { ConsignmentService } from '../../../consignment/services/consignment.service';
import { ReservationPaymentService } from '../../../reservation/services/reservation-payment.service';
import { RepurchaseWithdrawalTicketService } from '../../../repurchase/services/repurchase-withdrawal-ticket.service';
import { RepurchaseRenewalTicketService } from '../../../repurchase/services/repurchase-renewal-ticket.service';
import { CashMovementService } from '../../../cashmovements/services/cash-movement.service';
import { ConsignmentProductStatusService } from '../../../consignment/services/consignment-product-status.service';

import * as _ from 'lodash/lodash';
import * as FileSaver from 'file-saver';
import * as moment from 'moment/moment';
import { filter } from 'rxjs/operator/filter';
import { TurnSummaryService } from '../../services/turn-summary.service';


import pdfMake from 'pdfmake/build/pdfmake';
import {PdfMakeWrapper,Img,Txt,Table,Cell} from 'pdfmake-wrapper';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs; 


declare var JSZip: any;
declare var Docxtemplater: any;
declare var JSZipUtils: any;
declare var ImageModule: any;
declare var fs: any;
declare var Buffer: any;

@Component({
    selector: 'app-tpv',
    templateUrl: './tpv.component.html',
    styleUrls: ['./tpv.component.css'],
    providers:[LabeledProductService,SaleProductService,SaleService,PersonService,CounterService,
        InvoiceService,OrderService,OrderProductService,ShopService,SaleReturnService,RepurchaseRenewalService,
        TechnicalserviceService,PurchaseService,ExpensesService,RepurchaseService,UserService,TurnSummaryService,ConsignmentService,
        ReservationPaymentService,RepurchaseWithdrawalTicketService,RepurchaseRenewalTicketService,CashMovementService,ProductService,
        ConsignmentProductStatusService, LabeledProductShopStockService]

  })

export class TPVComponent implements OnInit {
    barcode: number;
    labeledProduct:any = {};
    labeledProductShopsStock:any = {
        stock:0
    };
    tpv:any = {
        sale_price_with_discount:0,
        quantity: 1,    
    };
    saleProducts:any =[];//Array utilizado para nuevas compras, y utilizado en ediciones para los articulos que pertenecen ya a la compra no han sido añadido nuevos
    saleProductsToDelete:any =[];//Array utilizado en ediciones para marcar los articulos que ya estaban guardados como que hay que borrarlos
    saleProductsToAdd:any =[];//Array utilizado en ediciones para los articulos que se añaden nuevos
    totalSale:number = 0;
    enableGenerateInvoice:boolean = false;
    person:any = {};
    id: number = undefined;
    private sub: any;
    sale:any = {
        number:undefined,
        date:new Date()
    };
    photos: any = [];
    method_of_payment: string = '';
    total_credit_card: number = 0;
    total_cash: number = 0;
    total_delivered: number = 0;
    total_change: number = 0;
    addressTicket:string='';
    createdTicket:string='';
    addDiscount:boolean = false;
    reference: string = '';
    tpvOnline: boolean = false;
    dailySummary: any = {
        salesReturn:{}
    };
    dailySummarySales: any = [];
    shopSerie: string = '';
    dailySummaryFilters: any = {
        date: null,
        shop_id: null,
        user_id: null
    };
    shops:any = [];
    users:any = [];
    user:any = {};
    shop:any = {};
    shopId:number;
    userId:number;
    now:any = moment().lang("es").format('dddd DD [de] MMMM [de] YYYY');
    
    tpvTurnSummary:boolean = false;
    coins:any = {
        oneCent: 0,
        twoCents: 0,
        fiveCents: 0,
        tenCents: 0,
        twentyCents: 0,
        fiftyCents: 0,
        oneEuro: 0,
        twoEuros: 0,
        fiveEuros: 0,
        tenEuros: 0,
        twentyEuros: 0,
        fiftyEuros: 0,
        hundredEuros: 0,
        twoHundredEuros: 0,
        fiveHundredEuros: 0
    };
    openSummary: boolean = true;
    lastSummary: any = {};
    difference: any;
    cashShouldBeInTPV:number = 0;
    cashAfterCount:number = 0;
    textDifferenceClose :string;
    acceptDifference : boolean = false;
    closeDifference: any;
    turn:any;
    dailySummaryUser: any={};
    isFromConsignment: boolean = false;
    labeledproductIdConsignmentProductIdMapping:any=[];

    constructor(private labeledProductService:LabeledProductService,private saleProductService:SaleProductService,private saleService:SaleService,private counterService:CounterService,
                private personService: PersonService,public toastr: ToastsManager,vcr: ViewContainerRef,private route: ActivatedRoute, private router: Router,
                private invoiceService:InvoiceService, private orderService:OrderService, private orderProductService:OrderProductService,private shopService:ShopService,
                private saleReturnService:SaleReturnService, private repurchaseRenewalService:RepurchaseRenewalService, private technicalserviceService:TechnicalserviceService,
                private purchaseService:PurchaseService, private expensesService:ExpensesService, private repurchaseService:RepurchaseService, private userService: UserService,
                private turnSummaryService:TurnSummaryService,private ConsignmentService:ConsignmentService,private reservationPaymentService:ReservationPaymentService,
                private repurchaseWithdrawalTicketService:RepurchaseWithdrawalTicketService, private repurchaseRenewalTicketService:RepurchaseRenewalTicketService,
                private cashMovementService: CashMovementService, private productService:ProductService, private consignmentProductStatusService:ConsignmentProductStatusService,
                private labeledProductShopStockService:LabeledProductShopStockService) {
                    this.toastr.setRootViewContainerRef(vcr);  
                }
                role:number = 3;

    ngOnInit() {
        this.shopSerie = this.checkSerie(parseInt(localStorage.getItem('shop')));
        this.shopId = parseInt(localStorage.getItem('shop'));
        this.sub = this.route.params.subscribe(params => {
            if (params['id'] !== undefined){
              this.id = params['id'];
              this.getSale();
            }else if (this.router.url.includes("tpvOnline")){
                this.tpvOnline = true;
            }
            if (location.href.split('?')[1]){
                let result = JSON.parse('{"' + decodeURI(location.href.split('?')[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')                
                this.dailySummaryFilters.date = result['summarydate'];
                this.dailySummaryFilters.shop_id = result['summaryshop'];
                this.dailySummaryFilters.user_id = result['summaryuser'];
                this.getShops().then(()=>{
                    this.getUsers().then(()=>{
                        this.getDailySummary(false, true, true);
                    })
                })
            }
          });
        this.role = JSON.parse(localStorage.getItem('user')).role;
        this.userId = JSON.parse(localStorage.getItem('user')).id;
        this.getShops();
        this.getUsers();
        this.getLastSummary();
    }

    checkSerie(shopId){
        if (shopId == 1){
            return 'M';
        }else if (shopId == 5){
            return 'T';
        }else if (shopId == 7){
            return 'O';
        }else if (shopId == 8){
            return 'C';
        }
    }

    getShops(){
        return new Promise((resolve, reject) => {
            this.shopService.query({})
            .subscribe((shops) => {
                this.shops = shops;
                this.shop = this.shops.filter((e)=> e.id === this.shopId)[0];
                resolve();
            });
        });
    }

    getUsers(){
        return new Promise((resolve, reject) => {
        this.userService.query({})
            .subscribe((users) => {
                this.users = users;
                this.user = this.getUser(this.userId);
                resolve();
            });
        });
    }
    getUser(userId){
        let user = null
        this.users.forEach((e)=>{
            if (e.id == userId){
                user = e;
            }
        });
        return user;
    }

    checkOpenTurn(){
        if (!(this.lastSummary &&
            moment(this.lastSummary.date).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD") &&
            this.lastSummary.createdBy.id == this.userId)
        ){
            this.toastr.error('', 'Te recordamos que no has realizado la apertura hoy', {dismiss: "controlled",showCloseButton:true,toastLife: 4000});
            return false;
        }else{
            return true;
        }
    }

    findLabeledProduct(){
        this.checkOpenTurn();
        var params = {
            where: {barcode:this.barcode},
            sort: 'id DESC',
            limit: 2
        };
        this.labeledProductService.query(params).subscribe((labeledProducts) => {
            if (labeledProducts[0] && labeledProducts.length === 1){
                let params = {
                    labeledproduct: labeledProducts[0].id,
                    shop: this.shopId
                }
                this.labeledProductShopStockService.query(params).subscribe((labeledProductShopStock) => {
                    this.barcode = null;
                    if (this.labeledProduct && this.labeledProduct.id){
                        this.addLabeledProduct(false);
                    }
                    if (labeledProductShopStock[0] && labeledProductShopStock.length === 1){
                        this.labeledProductShopsStock = labeledProductShopStock[0];
                    }
                    this.labeledProduct = labeledProducts[0];
                    this.tpv.sale_price = this.labeledProduct.sale_price;
                    this.checkDiscount();
                    this.getProductPhotos(this.labeledProduct);  
                    this.getProductFromLabeledProductandIncomingEntity(this.labeledProduct);
                });
            }
        });
    }

    getProductFromLabeledProductandIncomingEntity(labeledProduct){
        var params = {
            where:{
                labeledproduct_id:labeledProduct.id 
            }
        }
        this.productService.query(params).subscribe((products) => {  
            if(products[0] && products[0].consignmentProduct && products[0].consignmentProduct.length > 0){
                this.isFromConsignment = true;
                this.labeledproductIdConsignmentProductIdMapping[labeledProduct.id ] = products[0].consignmentProduct[0].id
            }
        });
    }

    updateConsignmentProductStatus(quantity, labeledproductId, total){
        return new Promise((resolve, reject) => {
            if (this.labeledproductIdConsignmentProductIdMapping[labeledproductId]){
                var params = {
                    where: {
                        consignmentproduct:this.labeledproductIdConsignmentProductIdMapping[labeledproductId], 
                        status:1,
                        quantity:{
                            ">":0
                        }
                    }
                };
                this.consignmentProductStatusService.query(params).subscribe((statuses)=>{
                    if (statuses.length == 0){
                        this.toastr.error('', 'No se ha podido actualizar el estado del producto en consigna', {dismiss: "controlled",showCloseButton:true});
                        resolve(true);
                    }else{
                        let status = statuses[0]
                        let consignmentProductStatusBody = {
                            consignment_product_id: status.consignmentproduct.id,
                            product_consignment_status_id: 3,
                            quantity: quantity,
                            sale_price: total
                        }
                        this.consignmentProductStatusService.create(consignmentProductStatusBody)
                            .subscribe(() => {
                            let body = {
                                id: status.id, 
                                quantity: status.quantity - quantity
                            }
                            this.consignmentProductStatusService.update(body)
                            .subscribe(() => {
                                resolve(true);
                            });
                        });
                    }
                });
            }else{
                resolve(true);
            }
        });
        
    }

    checkIfItIsAConsignment(){
        if (this.isFromConsignment == true){
            this.toastr.error('', '¿Está seguro de cambiar el precio? Se trata de una consigna', {dismiss: "controlled",showCloseButton:true});
        }
    }

    getSale(){
        this.addDiscount=false;
        this.saleService.get(this.id).subscribe((sale) => { 
            let params ={
              sale_id: sale.id
            }
            this.sale = sale;
            this.totalSale = this.sale.total;
            this.total_delivered = this.sale.total_delivered;
            this.total_change = this.sale.total_change;
            this.addressTicket=this.sale.shop.address;
            this.createdTicket=this.sale.createdBy.name;
            this.tpv.payment_method = sale.method_of_payment ==  "Efectivo"? 1:sale.method_of_payment ==  "Tarjeta"? 2:sale.method_of_payment ==  "Mixto"? 3:4;
            if (this.tpv.payment_method == 4){
                this.tpv.payment_method_others = sale.method_of_payment;
            }
            this.saleProductService.query(params).subscribe((saleProducts) =>{
                saleProducts.forEach((s)=>{
                    s.name = s.labeledproduct.name;
                    s.imei = (s.labeledproduct.imei1?s.labeledproduct.imei1:'') +" "+ (s.labeledproduct.imei2?s.labeledproduct.imei2:'');
                    s.serial_number = s.labeledproduct.serial_number;
                });
                this.saleProducts = saleProducts;
                this.saleProducts.forEach((saleProduct)=>{
                    this.checkDiscountForTicket(saleProduct);
                })                  
            });   
        });
    }

    checkDiscount(){
        var sale_price_with_quantity = parseFloat(this.tpv.sale_price) * this.tpv.quantity;
        var res = this.tpv.discount?this.tpv.discount.split("%"):""; 
        var res2 = this.tpv.discount?this.tpv.discount.split("e"):"";
        if (res.length > 1){//Percentage
            this.tpv.sale_price_with_discount = this.roundValue(sale_price_with_quantity - ((parseFloat(res[0]) * (sale_price_with_quantity/ 100))));
        }else if (res2.length > 1){//Money
            this.tpv.sale_price_with_discount = this.roundValue(sale_price_with_quantity - parseFloat(res[0]));
        }else{
            this.tpv.sale_price_with_discount = this.roundValue(sale_price_with_quantity);
        }
        this.calculateTotal();
    }

    calculateTotal(){
        this.tpv.total = this.roundValue(this.tpv.sale_price_with_discount);
    }

    checkAlreadyAddedProductsForStock(labeledProduct){
        let totalStockAdded = 0
        this.saleProducts.forEach((s)=>{
            if (s.labeledproduct_id === labeledProduct.id)
                totalStockAdded += s.quantity;
        })
        return totalStockAdded;
    }

    addLabeledProduct(cleanFields){
        if (this.labeledProductShopsStock.stock >= parseInt(this.tpv.quantity)+ this.checkAlreadyAddedProductsForStock(this.labeledProduct)){
            if (!this.id){
                let product = {
                    barcode:this.labeledProduct.barcode,
                    name:this.labeledProduct.name,
                    imei:(this.labeledProduct.imei1?this.labeledProduct.imei1:"") + " " + (this.labeledProduct.imei2?this.labeledProduct.imei2:""),
                    serial_number:this.labeledProduct.serial_number,
                    quantity:this.tpv.quantity,
                    sale_price:this.tpv.sale_price,
                    discount:this.tpv.discount,
                    total:this.tpv.total,
                    labeledproduct_id:this.labeledProduct.id
                }
                this.saleProducts.push(product);
                this.totalSale = this.roundValue(this.totalSale + parseFloat(this.tpv.total));
                if (cleanFields){
                    this.labeledProduct = {};
                    this.tpv.sale_price = null;
                    this.tpv.total = null;
                    this.tpv.quantity = 1;
                    this.tpv.discount = null;
                    this.photos=[];
                    this.barcode=null;
                }
            }else if (this.id){
                let product = {
                    barcode:this.labeledProduct.barcode,
                    name:this.labeledProduct.name,
                    imei:(this.labeledProduct.imei1?this.labeledProduct.imei1:"") + " " + (this.labeledProduct.imei2?this.labeledProduct.imei2:""),
                    serial_number:this.labeledProduct.serial_number,
                    quantity:this.tpv.quantity,
                    sale_price:this.tpv.sale_price,
                    discount:this.tpv.discount,
                    total:this.tpv.total,
                    labeledproduct_id:this.labeledProduct.id
                }
                this.saleProductsToAdd.push(product);
                this.totalSale = this.roundValue(this.totalSale + parseFloat(this.tpv.total));
                if (cleanFields){
                    this.labeledProduct = {};
                    this.tpv.sale_price = null;
                    this.tpv.total = null;
                    this.tpv.quantity = 1;
                    this.tpv.discount = null;
                    this.photos=[];
                    this.barcode=null;
                }    
            }
        }else{
            this.toastr.error('', 'Stock insuficiente', {dismiss: "controlled",showCloseButton:true,toastLife: 4000});
        }  
    }

    calculateTotalChange(){
        if (this.total_cash > 0){
            this.total_change = this.roundValue(this.total_delivered - this.total_cash);
        }else {
            this.total_change = this.roundValue(this.total_delivered - this.totalSale);
        }
    }

    // getOnlineOrder(){
    //     var params = {
    //         reference: this.reference
    //     }
    //     this.orderService.query(params).subscribe((order) => {
    //         var params2 = {
    //             prestashop_order_id: order[0].prestashop_order_id
    //         }
    //         this.orderProductService.query(params2).subscribe((orderproducts) => {
    //             let params3 = {
    //                 where:{
    //                   prestashop_product_id:_.compact(orderproducts.map(e => e.prestashop_product_id))
    //                 }
    //               };
    //               this.labeledProductService.query(params3)
    //               .subscribe((labeledProducts) => {
    //                   labeledProducts.forEach((labeledProduct)=>{
    //                     let index = _.findIndex(orderproducts, (e)=>{ return e.prestashop_product_id === labeledProduct.prestashop_product_id})
    //                     let product = {
    //                         barcode:labeledProduct.barcode,
    //                         name:labeledProduct.name,
    //                         imei:labeledProduct.imei1,
    //                         serial_number:labeledProduct.serial_number,
    //                         quantity:orderproducts[index].quantity,
    //                         sale_price:labeledProduct.sale_price,
    //                         discount:0,
    //                         total:labeledProduct.sale_price,
    //                         labeledproduct_id:labeledProduct.id
    //                     }
    //                     this.saleProducts.push(product);
    //                     this.totalSale += parseFloat(labeledProduct.sale_price);
    //                   })
    //               });
    //         });
    //     });
    // }

    // doOnlineSale(){
    //     let sale = {
    //         number: 1,
    //         number_with_serie:'',
    //         date:new Date(),
    //         total: this.totalSale,
    //         total_credit_card: this.total_credit_card,
    //         total_cash: this.total_cash,
    //         total_delivered: this.total_delivered,
    //         total_change: this.total_change,
    //         method_of_payment: this.tpv.payment_method == 1?"Efectivo":this.tpv.payment_method ==2 ?"Tarjeta":this.tpv.payment_method == 3?"Mixto":this.tpv.payment_method == 4?this.tpv.payment_method_others:null,                
    //         shop: 7
    //     } 
    //     if (sale.method_of_payment){
    //         this.checkCounterNumber(this.checkSerie(7)+"_"+CounterSettings.TICKET_COUNTER_LABEL, moment().year()).then((counter:number) =>{
    //             sale.number = counter;
    //             sale.number_with_serie = this.checkSerie(7)+counter;
    //             this.saleService.create(sale).subscribe((sale) => {
    //                 this.method_of_payment = sale.method_of_payment;
    //                 this.sale.number=sale.number;
    //                 this.sale.date=sale.date;
    //                 let observableSaleProductsRequests = [];
    //                 this.saleProducts.forEach((saleProduct)=>{
    //                     let object = {
    //                         sale_id: sale.id,
    //                         barcode: saleProduct.barcode?saleProduct.barcode:"",
    //                         description: saleProduct.description? saleProduct.description:"",
    //                         quantity: saleProduct.quantity?saleProduct.quantity:1,
    //                         sale_price: saleProduct.sale_price,
    //                         discount: saleProduct.discount?saleProduct.discount:"",
    //                         total:saleProduct.total,
    //                         labeledproduct_id: saleProduct.labeledproduct_id,
    //                         method_of_payment:saleProduct.method_of_payment,
    //                     }
    //                     this.checkDiscountForTicket(saleProduct);
    //                     observableSaleProductsRequests.push(this.saleProductService.create(object));
    //                 });
    //                 Observable.forkJoin(observableSaleProductsRequests)
    //                     .subscribe(data => {

    //                         this.saleService.get(sale.id).subscribe((sale) =>{ 
    //                             this.addressTicket=sale.shop.address;
    //                             this.createdTicket=sale.createdBy.name;
    //                             this.printTicket();  
    //                             location.reload();          
    //                         });
    //                     });
    //             });
    //         });
    //     }else{
    //         this.saleProducts.forEach((saleProduct)=>{
    //             this.incrementProductStock(saleProduct.labeledproduct_id, saleProduct.stock, saleProduct.generalStock);
    //         });
    //         this.toastr.error('', 'Debe seleccionar un método de pago', {dismiss: "controlled",showCloseButton:true,toastLife: 4000});
    //     }
    // }

    addLastProduct(){
        if (this.labeledProduct.barcode != undefined){
            this.addLabeledProduct(true);
        }
    }

    doSale(){
        this.addDiscount=false;
        if (!this.id){
            this.checkAndupdateStock(this.saleProducts).then(()=>{
                let sale = {
                    number: 1,
                    number_with_serie:'',
                    date:new Date(),
                    total: this.totalSale,
                    total_credit_card: this.total_credit_card,
                    total_cash: this.total_cash,
                    total_delivered: this.total_delivered,
                    total_change: this.total_change,
                    method_of_payment: this.tpv.payment_method == 1?"Efectivo":this.tpv.payment_method ==2 ?"Tarjeta":this.tpv.payment_method == 3?"Mixto":this.tpv.payment_method == 4?this.tpv.payment_method_others:null,                       
                } 
                if (sale.method_of_payment){
                    var params = {
                        sort: 'id DESC',
                        skip: 0,
                        limit: 1
                    };
                    this.checkCounterNumber(this.shopSerie+"_"+CounterSettings.TICKET_COUNTER_LABEL, moment().year()).then((counter:number) =>{
                        sale.number = counter;
                        sale.number_with_serie = this.shopSerie+counter;
                        this.saleService.create(sale).subscribe((sale) => {
                            this.method_of_payment = sale.method_of_payment;
                            this.sale.number = sale.number;
                            this.sale.date = sale.date;
                            let observableSaleProductsRequests = [];
                            this.saleProducts.forEach((saleProduct)=>{
                                let object = {
                                    sale_id: sale.id,
                                    barcode: saleProduct.barcode?saleProduct.barcode:"",
                                    description: saleProduct.description? saleProduct.description:"",
                                    quantity: saleProduct.quantity?saleProduct.quantity:1,
                                    sale_price: saleProduct.sale_price,
                                    discount: saleProduct.discount?saleProduct.discount:"",
                                    total:saleProduct.total,
                                    labeledproduct_id: saleProduct.labeledproduct_id,
                                    method_of_payment:saleProduct.method_of_payment,
                                }
                                this.checkDiscountForTicket(saleProduct);
                                this.updateConsignmentProductStatus(saleProduct.quantity,saleProduct.labeledproduct_id,saleProduct.total);
                                observableSaleProductsRequests.push(this.saleProductService.create(object));
                            });
                            Observable.forkJoin(observableSaleProductsRequests)
                                .subscribe(data => {    
                                    this.saleService.get(sale.id).subscribe((sale) => {
                                        this.addressTicket = sale.shop.address;
                                        this.createdTicket = sale.createdBy.name;
                                        this.sale = sale;
                                        setTimeout( ()=>{
                                            this.printTicket();
                                            location.reload(); 
                                        },0)              
                                    });
                            }); 
                        });
                    });
                }else{
                    this.saleProducts.forEach((saleProduct)=>{
                        this.incrementProductStock(saleProduct.labeledproduct_id, saleProduct.stock, saleProduct.generalStock);
                    });
                    this.toastr.error('', 'Debe seleccionar un método de pago', {dismiss: "controlled",showCloseButton:true,toastLife: 4000});
                }
            }).catch((err) =>{
                this.saleProducts.forEach((saleProduct)=>{
                    this.incrementProductStock(saleProduct.labeledproduct_id, saleProduct.stock, saleProduct.generalStock);
                });
            }); 
        }else if (this.id){
            this.checkAndupdateStock(this.saleProductsToAdd).then(()=>{ 
                this.sale.total = this.totalSale;
                this.sale.total_delivered = this.total_delivered ;
                this.sale.total_change = this.total_change;
                this.sale.method_of_payment = this.tpv.payment_method == 1?"Efectivo":this.tpv.payment_method ==2 ?"Tarjeta":this.tpv.payment_method == 3?"Mixto":this.tpv.payment_method == 4?this.tpv.payment_method_others:null;
                if(this.sale.method_of_payment!=="Efectivo"){
                        this.sale.total_delivered= 0,
                        this.sale.total_change=0
                }
                if (this.sale.method_of_payment){
                    this.saleService.update(this.sale).subscribe((sale) => {
                        let observableSaleProductsRequests = [];
                        if (this.saleProductsToAdd.length > 0){
                            this.saleProductsToAdd.forEach((saleProduct)=>{
                                let object = {
                                    sale_id: sale.id,
                                    barcode: saleProduct.barcode?saleProduct.barcode:"",
                                    description: saleProduct.description? saleProduct.description:"",
                                    quantity: saleProduct.quantity?saleProduct.quantity:1,
                                    sale_price: saleProduct.sale_price,
                                    discount: saleProduct.discount?saleProduct.discount:"",
                                    total:saleProduct.total,
                                    labeledproduct_id: saleProduct.labeledproduct_id,

                                }
                                this.checkDiscountForTicket(saleProduct);
                                observableSaleProductsRequests.push(this.saleProductService.create(object));
                            });
                            Observable.forkJoin(observableSaleProductsRequests)
                                .subscribe(data => {
                                    this.saleProductsToAdd = [];
                                    if (this.saleProductsToDelete.length > 0){
                                        this.deleteSaleProducts();
                                    }else{
                                        location.reload();
                                    }
                                });
                        }else{
                            if (this.saleProductsToDelete.length > 0){
                                this.deleteSaleProducts();
                            }else{
                                location.reload();
                            }
                        }
                    });
                }else{
                    this.saleProductsToAdd.forEach((saleProduct)=>{
                        this.incrementProductStock(saleProduct.labeledproduct_id, saleProduct.stock, saleProduct.generalStock);
                    });
                    this.toastr.error('', 'Debe seleccionar un método de pago', {dismiss: "controlled",showCloseButton:true,toastLife: 4000});
                }
            }).catch((err) =>{
                this.saleProductsToAdd.forEach((saleProduct)=>{
                    this.incrementProductStock(saleProduct.labeledproduct_id, saleProduct.stock, saleProduct.generalStock);
                });
            }); 
            this.toastr.success('', 'Compra actualizada', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
        }
    }

    updateSaleNotAdmin(){
        if (this.id){
            this.sale.method_of_payment = this.tpv.payment_method == 1?"Efectivo":this.tpv.payment_method ==2 ?"Tarjeta":this.tpv.payment_method == 3?"Mixto":this.tpv.payment_method == 4?this.tpv.payment_method_others:null;
             if(this.sale.method_of_payment!=="Efectivo"){
                        this.sale.total_delivered= 0,
                        this.sale.total_change=0
            }
            if (this.sale.method_of_payment){
                this.saleService.update({method_of_payment:this.sale.method_of_payment,id:this.sale.id,total_delivered:this.sale.total_delivered,total_change:this.sale.total_change}).subscribe((sale) => {
                    this.toastr.success('', 'Compra actualizada', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                    this.getSale();
                });
            }
        }
        console.log("dentro")
    }

    checkDiscountForTicket(saleProduct){
        if (saleProduct.discount!==null && saleProduct.discount !== '' && saleProduct.discount !== undefined){
            this.addDiscount=true;
        }
    }

    printTicket(){    
        document.getElementById("ticket").classList.remove('hide');
        window.print();
        document.getElementById("ticket").classList.add('hide');   
    }

    printTicketPreBox(){    
        document.getElementById("daily-summary").classList.remove('hide');
        window.print();
        document.getElementById("daily-summary").classList.add('hide');   
    }
   
    getProductPhotos(labeledProduct){
        this.labeledProductService.getProductPhotos(labeledProduct.id)
        .subscribe((result) => {
            this.photos = result;
            
        })
    }
    addProductsToBeDeleted(product){
        let index = _.findIndex(this.saleProducts,(e)=> e.labeledproduct_id === product.labeledproduct_id);
        if (index !== -1){
            this.totalSale = this.roundValue(this.totalSale - this.saleProducts[index].total);
            this.saleProductsToDelete.push(this.saleProducts[index]);
            this.saleProducts.splice(index,1);

        }else{//Si se trata de un producto que acabamos de añadir en una edición (no en una venta nueva), hay que eliminar de otro array
            let index = _.findIndex(this.saleProductsToAdd,(e)=> e.labeledproduct_id === product.labeledproduct_id);
            if (index !== -1){
                this.totalSale = this.roundValue(this.totalSale - this.saleProducts[index].total);
                this.saleProductsToAdd.splice(index,1);
            }
        }
    }

    deleteSaleProducts(){
        let observableSaleProductsRequests = [];
        this.saleProductsToDelete.forEach((saleProduct)=>{//Lo borramos de los productos relacionados con la venta.
            observableSaleProductsRequests.push(this.saleProductService.delete(saleProduct.id));
        });
        Observable.forkJoin(observableSaleProductsRequests)
            .subscribe(data => {
                this.saleProductsToDelete.forEach((saleProduct, index)=>{
                    this.labeledProductService.get(saleProduct.labeledproduct_id).subscribe((labeledProduct) => {
                        let object = {
                            id: saleProduct.labeledproduct_id,
                            stock: labeledProduct.stock + saleProduct.quantity
                        };
                        this.labeledProductService.update(object).subscribe((result) => {
                            this.saleProductsToDelete.splice(index,1);
                            if (this.saleProductsToDelete.length == 0){
                                location.reload();
                            }
                        });
                    });
                });
                
            });
    }

    checkAndupdateStock(saleProducts){
        return new Promise((resolve, reject) => {
            if (saleProducts.length < 1){
                resolve();
            }
            let labeledProductsForUpdate = [];
            let insufficientStock = false;
            let productsPendingToProcess = saleProducts.length;
            saleProducts.forEach((saleProduct)=>{
                this.labeledProductService.get(saleProduct.labeledproduct_id).subscribe((labeledProduct) => {
                    let generalStock = labeledProduct.stock;
                    let params = {
                        labeledproduct: labeledProduct.id,
                        shop: this.shopId
                    }
                    this.labeledProductShopStockService.query(params).subscribe((labeledProductShopStock) => {
                        var shopStock = 0
                        if (labeledProductShopStock[0] && labeledProductShopStock.length === 1){
                            shopStock = labeledProductShopStock[0].stock;
                        }
                        if (shopStock > 0 && shopStock >= saleProduct.quantity){
                            labeledProductsForUpdate.push({id:labeledProduct.id, stock:shopStock, quantity:saleProduct.quantity, generalStock:generalStock});
                            productsPendingToProcess = productsPendingToProcess - 1
                        }else{
                            this.toastr.error('', 'El Producto '+labeledProduct.barcode+' no tiene suficiente stock', {dismiss: "controlled",showCloseButton:true,toastLife: 4000});
                            insufficientStock = true;
                            productsPendingToProcess = productsPendingToProcess - 1;
                        }
                        if (insufficientStock && productsPendingToProcess == 0){
                            this.toastr.error('', 'La compra no se ha realizado debido a que no hay suficiente stock de productos, compruebe el stock y realice la compra de nuevo.', {dismiss: "controlled",showCloseButton:true,toastLife: 4000});
                            reject();   
                        }else if (!insufficientStock && productsPendingToProcess == 0){
                            labeledProductsForUpdate.forEach((labeledProductsUpdated)=>{
                                this.decreaseProductStock(labeledProductsUpdated.id, labeledProductsUpdated.stock, labeledProductsUpdated.quantity, labeledProductsUpdated.generalStock);
                            });
                            resolve();
                        }
                    });
                });
            });
        });
    }

    checkCounterNumber(counterName, year){
        return new Promise((resolve, reject) => {
            let params = {
                where: {
                    name:counterName, 
                    year: year
                }
            }
            this.counterService.query(params).subscribe((result) => {
                result = result[0];
                if (result === undefined){
                    this.counterService.create({name:counterName,year: year,counter:1}).subscribe(() => {
                        resolve(1)
                    });
                }else{
                    this.counterService.update({id:result.id,counter:result.counter + 1}).subscribe(() => {
                        resolve(result.counter + 1)
                    });
                }
            });
        });
    }

    decreaseProductStock(labeledProductId, stock, quantity, generalStock){
        let object = {
            id: labeledProductId,
            generalStock: generalStock - quantity,
            stock: stock - quantity,
            shop_id: this.shopId
        };
        this.labeledProductService.updateStockAndShopStock(object).subscribe((result) => {
        });
    }

    incrementProductStock(labeledProductId, stock, generalStock){
        let object = {
            id: labeledProductId,
            generalStock: generalStock,
            stock: stock,
            shop_id: this.shopId
        };
        this.labeledProductService.updateStockAndShopStock(object).subscribe((result) => {
        });
    }

    findPerson(){
        let nif = this.person.nif;
        this.person = {};
        let params={
          nif: nif
        }
        this.personService.query(params)
        .subscribe((people) => {
            if (people[0] === undefined){
                this.person.nif = nif;
            }else{
                var person = people[0];
                this.person = person;
            }
        });
    }

    savePerson(){
        this.personService.create(this.returnProperties(this.person))
        .subscribe((person) => {
            this.person = person;
        });
    }
    returnProperties(person){
        var properties = {
          nif: person.nif,
          name: person.name,
          surname: person.surname,
          address: person.address,
          cp: person.cp,
          town: person.town,
          state: person.state,
          telephone: person.telephone,
          mobile: person.mobile
        }
        if (person.id){
          properties['id'] = person.id;
        }
        return properties;
    }

    roundValue(value){
        return Math.round(value * 100) / 100;
    }


    loadFile(url,callback){
        JSZipUtils.getBinaryContent(url,callback);
    }

    generateInvoice(){
        if (this.sale.invoice_id){
            this.invoiceService.get(this.sale.invoice_id).subscribe((invoice)=>{
                invoice.ticketNumber = this.sale.number_with_serie;
               //this.download(invoice);
               this.generatePDF(invoice);
            });
        }else{
            this.checkCounterNumber(this.checkSerie(this.sale.shop.id)+"_"+CounterSettings.INVOICE_COUNTER_LABEL, moment().year()).then((counter:number) =>{
                let invoice = {
                    number: counter,
                    serie: this.checkSerie(this.sale.shop.id)+'F',
                    date: new Date(),
                    customer_name: (this.person.name != undefined? this.person.name: '')+" "+(this.person.surname != undefined? this.person.surname: ''),  
                    customer_nif: this.person.nif != undefined? this.person.nif:'',
                    customer_address: this.person.address != undefined? this.person.address:'',
                    customer_cp: this.person.cp != undefined? this.person.cp:'',
                    customer_state: this.person.state != undefined? this.person.state:'',
                    customer_phone1: this.person.telephone !=undefined? this.person.telephone:'',
                    customer_phone2: this.person.mobile != undefined? this.person.mobile:'',
                    tax: 0,
                    tax_amount: 0,
                    total_amount: this.totalSale != undefined? this.totalSale:'',
                }
                this.invoiceService.create(invoice).subscribe((invoice)=>{
                    this.saleService.update({id:this.sale.id, invoice_id: invoice.id}).subscribe(()=>{
                        invoice.ticketNumber = this.sale.number_with_serie;
                        this.generatePDF(invoice);
                        this.sale.invoice_id = invoice.id;
                        //this.download(invoice);
                    });
                });
            });
        }
    }


    generatePDF(invoice) {     
        invoice.phone = invoice.customer_phone1 + ', ' + invoice.customer_phone2;
        invoice.number_pdf = invoice.serie + invoice.number;
        invoice.totalPDF = "IMPORTE TOTAL: " + invoice.total_amount +'€';
        var tpvs = [];
        this.saleProducts.forEach(function (product){
            product.imei = product.imei?product.imei:"";
            tpvs.push(product)
        })
        const pdf = new PdfMakeWrapper();     
        new Img('https://app.masconberto.com/assets/img/logomasconberto.png').build().then(img => {
        pdf.add(img);
        pdf.add(new Table([
            [ 'ALBERTO H. RODRIGUEZ DELGADO',invoice.customer_name],
            [ '43.796.214-M',invoice.customer_nif],
            [ 'CL SAN FRANCISCO JAVIER 24',invoice.customer_address],
            [ '38001 STA CRUZ DE TENERIFE',invoice.customer_cp ],
            [ 'Tel. 822 04 16 50  657 06 11 00',invoice.phone],
            [ 'tienda@masconberto.com','']]).fontSize(10).widths(['65%', '35%']).margin([5,10,0,10]).layout('noBorders').end)
        pdf.add(new Txt('FACTURA').bold().fontSize(25).margin([5,10,0,10]).end)
        pdf.add(new Table([
            [(new Txt('Factura Nº:').end),(new Txt('Fecha:').end),(new Txt('Asociado al ticket:').end)
        ]]).margin([5,0,0,0]).layout('noBorders').widths(['35%', '35%','30%']).end)
        pdf.add(new Table([
        [(new Txt(invoice.number_pdf).end),(new Txt(moment(invoice.date).format("DD-MM-YYYY")).end),invoice.ticketNumber]]).layout('noBorders').widths(['35%', '35%','30%']).margin([5,0,0,5]).end)
        pdf.add(new Table([[
                new Txt('Código').bold().alignment('center').end,
                new Txt('Descripción').bold().end,
                new Txt('Cantidad').bold().end,
                new Txt('Precio Ud.').bold().end,
                new Txt('Dto.').bold().end,
                new Txt('Total').bold().end]]).fontSize(10).alignment('center').widths(['15%', '40%','11%','15%','10%','9%']).margin([0,10,0,0]).end)

        for(let i=0; i<tpvs.length;i++){ 
            tpvs[i].descriptionPDF = tpvs[i].name + tpvs[i].imei;
            tpvs[i].discount =  (tpvs[i].discount) != undefined? tpvs[i].discount:'';       
            pdf.add(
            new Table([[tpvs[i].barcode,(new Txt(tpvs[i].descriptionPDF).alignment('left').fontSize(9).end),tpvs[i].quantity,tpvs[i].sale_price,tpvs[i].discount,tpvs[i].total],
            ]).widths(['15%', '40%','11%','15%','10%','9%']).alignment('center').fontSize(9).end);     
        }  

        for(let i=tpvs.length; i<12;i++){ 
        pdf.add(
            new Table([['a','a','a','a','a','a']    
            ]).widths(['15%', '40%','11%','15%','10%','9%']).alignment('center').fontSize(9).margin([0,0,0,0]).color('#fff').end)
        }


        pdf.add(new Table([
            ['',invoice.totalPDF]    
            ]).widths(['50%','50%']).fontSize(15).margin([0,10,0,0]).layout('noBorders').alignment('right').bold().end)
            
            
        pdf.footer(new Txt ('PARA TRANSFERENCIAS: BBVA : ES68-0182-6601-61-0201582575').bold().fontSize(15).alignment('center').end);
            pdf.create().open();            
             });  
    }
    
    download(invoice){
        if (this.person.id == undefined && !this.sale.invoice_id){
            this.savePerson();
        }
        var opts = {
            centered : false,
            getImage: function(image){
                return image;
            },
            getSize: function(img,tagValue, tagName) {
                if (tagName == 'imageCB'){
                    return [100,33];}
                if (tagName == 'barcode'){
                    return [100,33]}
                else{
                    return [300,204];
                }
            }
        }
        var imageModule=new ImageModule(opts);
        var _this = this;
    
        this.loadFile("assets/tpv_template.docx",function(error,content){
        if (error) { 
            throw error 
        };
        var zip = new JSZip(content);
        var doc=new Docxtemplater()
                .attachModule(imageModule)
                .loadZip(zip)
        var tpvs = [];
        _this.saleProducts.forEach(function (product){
            product.imei = product.imei?product.imei:"";
            tpvs.push(product)
        })
        let user = JSON.parse(localStorage.getItem('user'))
        doc.setData({
            tpvs:tpvs,
            date:moment(invoice.date).format("DD-MM-YYYY"),
            num:invoice.number,
            ticket: "Asociado al ticket "+invoice.ticketNumber,
            serie:invoice.serie,
            name:invoice.customer_name,
            NIF:invoice.customer_nif,
            address:invoice.customer_address,
            cp:invoice.customer_cp,
            state:invoice.customer_state,
            phone1:invoice.customer_phone1 ,
            phone2:invoice.customer_phone2 ,
            total:invoice.total_amount,
            tax:invoice.tax,
            tax_amount:invoice.tax_amount,
            user:user.username
        });
        try {
            // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
            doc.render()
        }
        catch (error) {
            var e = {
                message: error.message,
                name: error.name,
                stack: error.stack,
                properties: error.properties,
            }
            console.log(JSON.stringify({error: e}));
            // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
            throw error;
        }
        var out=doc.getZip().generate({
            type:"blob",
            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            
        }) //Output the document using Data-URI
        //saveAs(out,"output.docx")
        FileSaver.saveAs(out, 'facturatpv.docx');  
        })
    }

    getDailySummary(saveResult, obtainCloseSummaryFromEmployee, goBack){
        let shop_id = localStorage.getItem('shop');
        let user = JSON.parse(localStorage.getItem('user'));
        let user_id = JSON.parse(localStorage.getItem('user')).id;
        let dateFilter = new Date();
        if (this.dailySummaryFilters.date){
            shop_id = this.dailySummaryFilters.shop_id;
            user_id = this.dailySummaryFilters.user_id;
            dateFilter = this.dailySummaryFilters.date;
        }
        user = this.getUser(user_id);
        this.dailySummaryUser = user;
        let date=moment(dateFilter).lang("es").format('dddd[,] DD [de] MMMM [de] YYYY'); 
        this.shopService.get(parseInt(shop_id)).subscribe((shop) => {
            let filters = {
                shop_id: shop_id,
                createdBy: user_id,
                date: {}
            }
            filters.date[">="] = moment(dateFilter).format("YYYY-MM-DD");
            filters.date["<"] = moment(dateFilter).add(1,'days').format("YYYY-MM-DD");
            var params = {
                where: _.cloneDeep(filters),
                sort: 'id DESC'
            };
            this.saleService.query(params)
                .subscribe((sales) => {
                    this.saleReturnService.query(params)
                    .subscribe((salesReturn) => {
                        console.log(sales)
                        this.dailySummarySales = sales;
                        this.dailySummary = {
                            total: 0,
                            total_sale: 0,
                            cash: 0,
                            credit_card: 0,
                            others: 0,
                            total_difference: 0,
                            total_difference_cash: 0,
                            username: user.username,
                            name: user.name,
                            surname: user.surname,
                            shop: shop,
                            date:date,
                            salesReturn: {},
                            total_cash:0
                        }
                        this.dailySummary.salesReturn.total = 0;
                        this.dailySummary.salesReturn.total_cash = 0;
                        this.dailySummary.salesReturn.total_credit_card = 0;
                        this.dailySummary.salesReturn.total_bizum = 0;
                        this.dailySummary.salesReturn.total_transfer = 0;
                        this.getRepurchasesWithdrawalForSummary(shop_id,user_id,dateFilter).then(()=>{
                            this.getRepurchasesRenewalsForSummary(shop_id,user_id,dateFilter).then(()=>{
                                this.getTechnicalServicesForSummary(shop_id,user_id,dateFilter).then(()=>{
                                    this.getPurchasesForSummary(shop_id,user_id,dateFilter).then(()=>{
                                        this.getRepurchasesForSummary(shop_id,user_id,dateFilter).then(()=>{
                                            this.getConsignmentForSummary(shop_id,user_id,dateFilter).then(()=>{
                                                this.getExpensesForSummary(shop_id,user_id,dateFilter).then(()=>{
                                                    this.getReservationForSummary(shop_id, user_id, dateFilter).then(()=>{
                                                        this.getCashMovementForSummary(shop_id, user_id, dateFilter).then(()=>{
                                                            this.dailySummarySales.forEach((e)=>{
                                                                let total = e.total;
                                                                if (e.reservation){
                                                                    total = e.reservation.total_pending;
                                                                }
                                                                if (e.method_of_payment == "Efectivo"){
                                                                    this.dailySummary.total += total;
                                                                    this.dailySummary.cash += total;
                                                                }else if (e.method_of_payment == "Tarjeta"){
                                                                    this.dailySummary.total += total;
                                                                    this.dailySummary.credit_card += total;
                                                                }else if (e.method_of_payment == "Mixto"){
                                                                    this.dailySummary.total += total;
                                                                    this.dailySummary.cash += e.total_cash;
                                                                    this.dailySummary.credit_card += e.total_credit_card;
                                                                }else{
                                                                    this.dailySummary.total += total;
                                                                    this.dailySummary.others += total;
                                                                }
                                                            });
                                                            this.dailySummary.total_difference_cash = this.dailySummary.cash;
                                                            salesReturn.forEach((sr)=>{
                                                                if (sr.method_of_payment == "Efectivo"){
                                                                    this.dailySummary.salesReturn.total_cash += sr.total;
                                                                    this.dailySummary.total_difference_cash += sr.total;
                                                                }else if (sr.method_of_payment == "Tarjeta"){
                                                                    this.dailySummary.salesReturn.total_credit_card += sr.total;
                                                                }else if (sr.method_of_payment == "Bizum"){
                                                                    this.dailySummary.salesReturn.total_bizum += sr.total;
                                                                }else if (sr.method_of_payment == "Transferencia"){
                                                                    this.dailySummary.salesReturn.total_transfer += sr.total;
                                                                }
                                                                this.dailySummary.salesReturn.total += sr.total;
                                                                this.dailySummarySales.push(sr);
                                                            });
                                                            this.dailySummary.salesReturn.total_credit_card = this.roundValue(this.dailySummary.salesReturn.total_credit_card);
                                                            this.dailySummary.salesReturn.total_cash = this.roundValue(this.dailySummary.salesReturn.total_cash);
                                                            this.dailySummarySales = _.orderBy(this.dailySummarySales, (e)=>{return e.number});
                                                            this.dailySummary.total_difference = this.dailySummary.total + this.dailySummary.salesReturn.total;
                                                            this.dailySummary.total_difference_cash = this.roundValue(this.dailySummary.total_difference_cash);
                                                            this.dailySummary.total = this.roundValue(this.dailySummary.total);
                                                            this.dailySummary.total_sale = this.roundValue(this.dailySummary.total);
                                                            this.dailySummary.cash = this.roundValue(this.dailySummary.cash);
                                                            this.dailySummary.credit_card = this.roundValue(this.dailySummary.credit_card);
                                                            this.dailySummary.others = this.roundValue(this.dailySummary.others);
                                                            this.dailySummary.total_income_cash = this.dailySummary.cash +  this.dailySummary["repurchaseWithdrawalTotalEfectivo"] +  this.dailySummary["repurchaseRenewalTotalEfectivo"] + this.dailySummary["technicalServiceTotalEfectivo"]
                                                            + this.dailySummary["reservationTotalCash"] + this.dailySummary['cashMovementsIn'].total;
                                                            this.dailySummary.total_income = this.dailySummary.total + this.dailySummary['cashMovementsIn'].total +
                                                            this.dailySummary.repurchaseWithdrawalTotal + this.dailySummary.repurchaseRenewalTotal + this.dailySummary.technicalServiceTotal +  this.dailySummary["reservationTotal"];
                                                            this.dailySummary.total_expenses_cash = (this.dailySummary.salesReturn.total_cash*-1) + this.dailySummary.purchasesTotalCash + this.dailySummary.repurchasesTotalCash + this.dailySummary.expensesTotalCash + this.dailySummary['cashMovementsOut'].total ;
                                                            if (saveResult){
                                                                this.setTPVSummaryInTurnSummary(this.dailySummary.total_income_cash - this.dailySummary.total_expenses_cash);
                                                            }else{
                                                                if (obtainCloseSummaryFromEmployee){
                                                                    let params:any = {
                                                                        where:{
                                                                            createdAt: {},
                                                                        }
                                                                    };
                                                                    params.where.shop = shop_id;
                                                                    params.where.createdBy = user_id;
                                                                    params.where['createdAt'][">="] = moment(dateFilter).format("YYYY-MM-DD");
                                                                    params.where['createdAt']["<"] = moment(dateFilter).add(1,'days').format("YYYY-MM-DD");
                                                                    this.turnSummaryService.query(params).subscribe((result)=>{
                                                                        if (result.length == 0){
                                                                            this.toastr.error('', 'Ese usuario no ha realizado apertura de caja ese día para esa tienda', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                                                                        }else{
                                                                            this.coins = JSON.parse(result[0].close_details)
                                                                            if (this.coins == null){
                                                                                this.initCoins();
                                                                            }
                                                                            this.cashShouldBeInTPV = this.roundValue(result[0].tpv_summary+ result[0].open_amount);
                                                                            this.closeDifference = result[0].current_difference < 0.01?0:result[0].current_difference;
                                                                            this.cashAfterCount = result[0].close_amount;
                                                                            if (parseInt(moment(result[0].createdAt).format("HH")) < 14){
                                                                                this.turn = "Mañana";
                                                                                if (parseInt(moment(result[0].updatedAt).format("HH")) > 16){
                                                                                    this.turn = "Partido";
                                                                                }
                                                                            }else if (parseInt(moment(result[0].createdAt).format("HH")) > 14){
                                                                                this.turn = "Tarde";
                                                                            }
                                                                            setTimeout(()=>{
                                                                                this.printCloseBox();
                                                                                if (goBack)
                                                                                    window.history.back();
                                                                            },100);
                                                                        }
                                                                    });
                                                                }else{
                                                                    setTimeout(()=>{
                                                                        this.printTicketPreBox();
                                                                    },100);
                                                                }
                                                            }
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });      
                        });
                    });
            });
        });
    }

    setTPVSummaryInTurnSummary(amount){
        let params:any = {
            where:{
                createdAt: {},
            }
        };
        params.where.shop = this.shopId;
        params.where.createdBy = this.userId;
        params.where['createdAt'][">="] = moment().format("YYYY-MM-DD");
        params.where['createdAt']["<"] = moment().add(1,'days').format("YYYY-MM-DD");
        this.turnSummaryService.query(params).subscribe((result)=>{
            let lastSummary = result[0];
            if (!lastSummary){
                this.toastr.error('', 'No se ha registrado el cierre de caja ya que no se ha hecho una apertura de caja para este usuario y día', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
            }else{
                if (parseInt(moment(lastSummary.createdAt).format("HH")) < 14){
                    this.turn = "Mañana";
                    if (parseInt(moment().format("HH")) > 16){
                        this.turn = "Partido";
                    }
                }else if (parseInt(moment(lastSummary.createdAt).format("HH")) > 14){
                    this.turn = "Tarde";
                }
                let body = {
                    id: lastSummary.id,
                    tpv_summary: amount 
                };
                this.turnSummaryService.update(body).subscribe(()=>{
                    this.toastr.success('', 'Cierre de caja registrado correctamente', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                    this.closeTPV();
                });
            }
        });
    }

    getRepurchasesWithdrawalForSummary(shop_id, user_id, date){
        return new Promise((resolve, reject) => {
            var params = {
                where: {
                    createdAt: {},
                    createdBy: user_id,
                    shop: shop_id 
                }
            };
            params.where['createdAt'][">="] = moment(date).format("YYYY-MM-DD");
            params.where['createdAt']["<"] = moment(date).add(1,'days').format("YYYY-MM-DD");
            this.repurchaseWithdrawalTicketService.query(params)
            .subscribe((repurchaseWithdrawal) => {
                this.dailySummary["repurchaseWithdrawal"] = repurchaseWithdrawal;
                this.dailySummary["repurchaseWithdrawalTotal"] = 0;
                this.dailySummary["repurchaseWithdrawalTotalEfectivo"] = 0;
                repurchaseWithdrawal.forEach((e)=>{
                    if (e.type === 2){
                        e.total = e.total*-1;
                    }
                    if (e.method_of_payment == "Efectivo"){
                        this.dailySummary["repurchaseWithdrawalTotalEfectivo"] += e.total;
                    }
                    this.dailySummary.total_difference += e.total;
                    this.dailySummary["repurchaseWithdrawalTotal"] += e.total;
                });
                resolve();
            });
        })
    }

    getRepurchasesRenewalsForSummary(shop_id, user_id, date){
        return new Promise((resolve, reject) => {
            var params = {
                where: {
                    createdAt: {},
                    createdBy: user_id,
                    shop: shop_id 
                }
            };
            params.where['createdAt'][">="] = moment(date).format("YYYY-MM-DD");
            params.where['createdAt']["<"] = moment(date).add(1,'days').format("YYYY-MM-DD");
            this.repurchaseRenewalTicketService.query(params)
            .subscribe((repurchaseRenewal) => {
                this.dailySummary["repurchaseRenewal"] = repurchaseRenewal;
                this.dailySummary["repurchaseRenewalTotal"] = 0;
                this.dailySummary["repurchaseRenewalTotalEfectivo"] = 0;
                repurchaseRenewal.forEach((e)=>{
                    if (e.type === 2){
                        e.partial_payment_with_igic = e.partial_payment_with_igic*-1;
                    }
                    if (e.method_of_payment == "Efectivo"){
                        this.dailySummary["repurchaseRenewalTotalEfectivo"] += e.partial_payment_with_igic;
                    }
                    this.dailySummary.total_difference += e.partial_payment_with_igic;
                    this.dailySummary["repurchaseRenewalTotal"] += this.roundValue(e.partial_payment_with_igic);
                });
                resolve();
            });
        })
    }

    getTechnicalServicesForSummary(shop_id, user_id, date){
        return new Promise((resolve, reject) => {
            var params = {
                where: {
                    withdrawal_date:  moment(date).format("YYYY-MM-DD"),
                    withdrawal_by: user_id,
                    withdrawal_shop: shop_id 
                }
            };
            this.technicalserviceService.query(params)
            .subscribe((technicalService) => {
                this.dailySummary["technicalService"] = technicalService;
                this.dailySummary["technicalServiceTotal"] = 0;
                this.dailySummary["technicalServiceTotalEfectivo"] = 0;
                technicalService.forEach((e)=>{
                    this.dailySummary["technicalServiceTotal"] += this.roundValue(e.net_total);
                    if (e.method_of_payment == "Efectivo"){
                        this.dailySummary["technicalServiceTotalEfectivo"] += e.net_total;
                    }
                });
                resolve();
            });
        })
    }

    getExpensesForSummary(shop_id, user_id, date){
    return new Promise((resolve, reject) => {
        var params = {
            where: {
                createdAt: {},
                createdBy: user_id,
                shop_id: shop_id 
            }
        };
        params.where['createdAt'][">="] = moment(date).format("YYYY-MM-DD");
        params.where['createdAt']["<"] = moment(date).add(1,'days').format("YYYY-MM-DD");
        this.expensesService.query(params)
        .subscribe((expenses) => {
            this.dailySummary["expenses"] = expenses;
            this.dailySummary["expensesTotal"] = 0;
            this.dailySummary["expensesTotalCash"] = 0;
            this.dailySummary["expensesTotalCredit"] = 0;
            this.dailySummary["expensesTotalOthers"] = 0;
            expenses.forEach((e)=>{
                if (e.method_of_payment == "Efectivo"){
                    this.dailySummary["expensesTotalCash"] += e.amount;
                }else if (e.method_of_payment == "Tarjeta"){
                    this.dailySummary["expensesTotalCredit"] += e.amount;
                }else{
                    this.dailySummary["expensesTotalOthers"] += e.amount;
                }
                this.dailySummary["expensesTotal"] += e.amount;
            });
            resolve();
        });
    
    })
}

    getPurchasesForSummary(shop_id, user_id, date){
        return new Promise((resolve, reject) => {
            var params = {
                where: {
                    date:  moment(date).format("YYYY-MM-DD"),
                    createdBy: user_id,
                    shop_id: shop_id 
                }
            };
            this.purchaseService.query(params)
            .subscribe((purchases) => {
                this.dailySummary["purchases"] = purchases;
                this.dailySummary["purchasesTotal"] = 0;
                this.dailySummary["purchasesTotalCash"] = 0;
                purchases.forEach((e)=>{
                    this.dailySummary["purchasesTotal"] += e.total_amount; 
                    if (e.method_of_payment === "Efectivo" || e.method_of_payment === null){
                        this.dailySummary["purchasesTotalCash"] += e.total_amount; 
                    }
                });
                resolve();
            });
        })
    }

    getReservationForSummary(shop_id, user_id, date){
        return new Promise((resolve, reject) => {
            var params = {
                where: {
                    createdAt: {},
                    createdBy: user_id,
                    shop_id: shop_id 
                }
            };
            params.where['createdAt'][">="] = moment(date).format("YYYY-MM-DD");
            params.where['createdAt']["<"] = moment(date).add(1,'days').format("YYYY-MM-DD");
            //Pagos a cuenta ( Los pagos a cuenta se meten en la caja, por tanto cuando se vende no hace falta peterlos de nuevo solo lo último pendiente, y las abandonadas no haría falta.)
            this.reservationPaymentService.query(params)
            .subscribe((reservation) => {
                this.dailySummary["reservation"] = reservation;
                this.dailySummary["reservationTotal"] = 0;
                this.dailySummary["reservationTotalCash"] = 0;
                reservation.forEach((e)=>{
                    this.dailySummary["reservationTotal"] += e.total_amount; 
                    if(e.method_of_payment === "Efectivo"){
                        this.dailySummary["reservationTotalCash"] += e.total_amount;
                    }
                });
                resolve();
            });
        })
    }

    getConsignmentForSummary(shop_id, user_id, date){
        return new Promise((resolve, reject) => {
            var params = {
                where: {
                    date:  moment(date).format("YYYY-MM-DD"),
                    createdBy: user_id,
                    shop_id: shop_id 
                }
            };
            this.ConsignmentService.query(params)
            .subscribe((consignments) => {
                this.dailySummary["consignment"] = consignments;
                this.dailySummary["consignmentTotal"] = 0;
                consignments.forEach((e)=>{
                   this.dailySummary["consignmentTotal"] += e.total_consignment_amount? e.total_consignment_amount:0; 
                });
                resolve();
            });
        })
    }

    getRepurchasesForSummary(shop_id, user_id, date){
        return new Promise((resolve, reject) => {
            var params = {
                where: {
                    init_date: moment(date).format("YYYY-MM-DD"),
                    createdBy: user_id,
                    shop_id: shop_id 
                }
            };
            this.repurchaseService.query(params)
            .subscribe((repurchases) => {
                this.dailySummary["repurchases"] = repurchases;
                this.dailySummary["repurchasesTotal"] = 0;
                this.dailySummary["repurchasesTotalCash"] = 0;
                repurchases.forEach((e)=>{
                   this.dailySummary["repurchasesTotal"] += e.total_purchase_amount; 
                   if (e.method_of_payment === "Efectivo" || e.method_of_payment === null){
                      this.dailySummary["repurchasesTotalCash"] += e.total_purchase_amount; 
                   }
                });
                resolve();
            });
        })
    }

    getCashMovementForSummary(shop_id, user_id, date){
        return new Promise((resolve, reject) => {
            var params = {
                where: {
                    createdAt: {},
                    createdBy: user_id,
                    or:[{
                        from_shop: shop_id},
                        {to_shop: shop_id
                    }]
                }
            };
            params.where['createdAt'][">="] = moment(date).format("YYYY-MM-DD");
            params.where['createdAt']["<"] = moment(date).add(1,'days').format("YYYY-MM-DD");
            this.cashMovementService.query(params)
            .subscribe((cashMovements) => {
                this.dailySummary["cashMovementsIn"] = {total:0};
                this.dailySummary["cashMovementsOut"] = {total:0};
                cashMovements.forEach((e)=>{
                    if (e.to_shop && e.to_shop.id == shop_id){
                        if (!this.dailySummary["cashMovementsIn"]["Trasvase "+(e.from_shop?e.from_shop.name:"Banco")+" a "+e.to_shop.name]){
                            this.dailySummary["cashMovementsIn"]["Trasvase "+(e.from_shop?e.from_shop.name:"Banco")+" a "+e.to_shop.name] = 0
                        }
                        this.dailySummary["cashMovementsIn"]["Trasvase "+(e.from_shop?e.from_shop.name:"Banco")+" a "+e.to_shop.name] += e.amount;
                        this.dailySummary["cashMovementsIn"].total +=e.amount;
                    }
                    if (e.from_shop && e.from_shop.id == shop_id){
                        if (!this.dailySummary["cashMovementsOut"]["Trasvase "+e.from_shop.name+" a "+(e.to_shop?e.to_shop.name:"Banco")]){
                            this.dailySummary["cashMovementsOut"]["Trasvase "+e.from_shop.name+" a "+(e.to_shop?e.to_shop.name:"Banco")] = 0
                        }
                        this.dailySummary["cashMovementsOut"]["Trasvase "+e.from_shop.name+" a "+(e.to_shop?e.to_shop.name:"Banco")] += e.amount
                        this.dailySummary["cashMovementsOut"].total +=e.amount;
                    }
                });
                resolve();
            });
        })
    }

    objectKeys(object){
        return Object.keys(object)
    }



    //TPV TURN CLOSE


    OpenTPV(){
        this.openSummary = true;
        this.getLastSummary();
        this.tpvTurnSummary = true;
    }

    closeTPV(){
        this.openSummary = false;
        this.getLastSummary();
        this.tpvTurnSummary = true;
    }


    calculateTotalCoins(){
        let total :number = 0;
        total += this.coins.oneCent * 0.01;
        total += this.coins.twoCents * 0.02;
        total += this.coins.fiveCents * 0.05;
        total += this.coins.tenCents * 0.10;
        total += this.coins.twentyCents * 0.20;
        total += this.coins.fiftyCents * 0.50;
        total += this.coins.oneEuro * 1;
        total += this.coins.twoEuros * 2;
        total += this.coins.fiveEuros * 5;
        total += this.coins.tenEuros * 10;
        total += this.coins.twentyEuros * 20;
        total += this.coins.fiftyEuros * 50;
        total += this.coins.hundredEuros * 100;
        total += this.coins.twoHundredEuros * 200;
        total += this.coins.fiveHundredEuros * 500;
        
        this.saveSummary(total);                  
    }

    saveSummary(total){
        if (this.openSummary){
            if (!this.lastSummary || this.lastSummary.createdBy.id != this.userId || moment(this.lastSummary.date).format("YYYY-MM-DD") != moment().format("YYYY-MM-DD")){
                this.difference = 0;
                if (this.lastSummary){
                    this.difference = this.roundValue(total - this.lastSummary.close_amount)
                };
                let body = {
                    date: moment().format("YYYY-MM-DD"),
                    open_details: JSON.stringify(this.coins),
                    shop: this.shopId,
                    previous_difference: this.difference,
                    open_amount: total
                }
                if (this.difference !== 0){
                    this.coinDifference();
                    if(this.difference > 0){
                        this.difference = "+"+this.difference;
                    }
                    else{
                        this.difference = "-"+this.difference;
                    }
                    if(this.acceptDifference === true){
                        this.turnSummaryService.create(body).subscribe(()=>{
                            this.tpvTurnSummary = false;
                            setTimeout( ()=>{
                                this.printOpenBox(); 
                                setTimeout( ()=>{
                                    this.toastr.success('', 'Apertura de turno realizada correctamente', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                                    this.initCoins();              
                                    location.reload();                      
                                },100)                                
                            },100)          
                        });
                        this.acceptDifference = false;
                    } 
                }else{
                    this.turnSummaryService.create(body).subscribe(()=>{
                        this.toastr.success('', 'Apertura de turno realizada correctamente', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                        location.reload();
                    });
                }
            }else{
                this.toastr.error('', 'Ya has realizado una apertura de turno para esta tienda hoy', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
            }
        }else{
            if (!this.lastSummary){
                this.toastr.error('', 'No se puede realizar un cierre de turno debido a que no hay una apertura de turno hoy para esta tienda y usuario', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
            }else{
                if (this.lastSummary.tpv_summary == null && this.lastSummary.tpv_summary == undefined){
                    this.toastr.error('', 'No se puede realizar un cierre de turno debido a que primero debes registrar el cierre de caja', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                }else{
                    this.cashShouldBeInTPV = this.lastSummary.tpv_summary + this.lastSummary.open_amount;
                    this.cashAfterCount = total;
                    let body = {
                        id: this.lastSummary.id,
                        close_details: JSON.stringify(this.coins),
                        current_difference: total - (this.lastSummary.tpv_summary + this.lastSummary.open_amount),
                        close_amount: total
                    };
                    this.closeDifference = this.roundValue(total - (this.lastSummary.tpv_summary + this.lastSummary.open_amount));
                    if (body.current_difference !== 0){
                        if(window.confirm('¿Está seguro de realizar el cierre de caja? Existe una diferencia de: '+this.roundValue(body.current_difference)+'€ respecto a la apertura')){
                            this.turnSummaryService.update(body).subscribe(()=>{
                                this.tpvTurnSummary = false;
                                this.initCoins();
                                this.printCloseBox();
                            });
                        }
                    }else{
                        this.turnSummaryService.update(body).subscribe(()=>{
                            this.tpvTurnSummary = false;
                            this.initCoins();
                            this.printCloseBox();
                        });
                    }
                }
            }
        } 
    }
    
    confirmOpen(){
        this.acceptDifference = true
        this.calculateTotalCoins();
    }
    
    unConfirmOpen(){
        location.reload();  
    }

    coinDifference(){  
        if (JSON.parse(this.lastSummary.close_details)) {
            this.textDifferenceClose = '¿Está seguro de realizar la apertura de caja? Existe una diferencia de: '+ this.difference +'€ respecto al último cierre: <br/>';
            if(this.coins.oneCent > JSON.parse(this.lastSummary.close_details).oneCent){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.oneCent - (JSON.parse(this.lastSummary.close_details).oneCent) ) +  ' ' + 'monedas de 1 céntimo  <br/>';
            }else if (this.coins.oneCent === JSON.parse(this.lastSummary.close_details).oneCent){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).oneCent - this.coins.oneCent ) +  ' ' + 'monedas de 1 céntimo <br/>';
            }
            if(this.coins.twoCents > JSON.parse(this.lastSummary.close_details).twoCents){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.twoCents - JSON.parse(this.lastSummary.close_details).twoCents ) +  ' ' + 'monedas de 2 céntimos <br/>';
            }else if (this.coins.twoCents === JSON.parse(this.lastSummary.close_details).twoCents){
                    this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).twoCents - this.coins.twoCents ) +  ' ' + 'monedas de 2 céntimos <br/>';
            }
            if(this.coins.fiveCents > JSON.parse(this.lastSummary.close_details).fiveCents){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.fiveCents - JSON.parse(this.lastSummary.close_details).fiveCents ) +  ' ' + 'monedas de 5 céntimos <br/>';
            }else if (this.coins.fiveCents === JSON.parse(this.lastSummary.close_details).fiveCents){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).fiveCents - this.coins.fiveCents ) +  ' ' + 'monedas de 5 céntimos <br/>';
            }
            if(this.coins.tenCents > JSON.parse(this.lastSummary.close_details).tenCents){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.tenCents - JSON.parse(this.lastSummary.close_details).tenCents ) +  ' ' + 'monedas de 10 céntimos <br/>';
            }else if (this.coins.tenCents === JSON.parse(this.lastSummary.close_details).tenCents){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).tenCents - this.coins.tenCents ) +  ' ' + 'monedas de 10 céntimos <br/>';
            }
            if(this.coins.twentyCents > JSON.parse(this.lastSummary.close_details).twentyCents){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.twentyCents - JSON.parse(this.lastSummary.close_details).twentyCents ) +  ' ' + 'monedas de 20 céntimos <br/>';
            }else if (this.coins.twentyCents === JSON.parse(this.lastSummary.close_details).twentyCents){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).twentyCents - this.coins.twentyCents ) +  ' ' + 'monedas de 20 céntimos <br/>';
            }
            if(this.coins.fiftyCents > JSON.parse(this.lastSummary.close_details).fiftyCents){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.fiftyCents - JSON.parse(this.lastSummary.close_details).fiftyCents ) +  ' ' + 'monedas de 50 céntimos <br/>';
            }else if (this.coins.fiftyCents === JSON.parse(this.lastSummary.close_details).fiftyCents){
                    this.textDifferenceClose += '';
            }else{
                    this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).fiftyCents - this.coins.fiftyCents ) +  ' ' + 'monedas de 50 céntimos <br/>';
            }
            if(this.coins.oneEuro > JSON.parse(this.lastSummary.close_details).oneEuro){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.oneEuro - JSON.parse(this.lastSummary.close_details).oneEuro ) +  ' ' + 'monedas de 1 euro <br/>';
            }else if (this.coins.oneEuro === JSON.parse(this.lastSummary.close_details).oneEuro){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).oneEuro - this.coins.oneEuro ) +  ' ' + 'monedas de 1 euro <br/>';
            }
            if(this.coins.twoEuros > JSON.parse(this.lastSummary.close_details).twoEuros){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.twoEuros - JSON.parse(this.lastSummary.close_details).twoEuros ) +  ' ' + 'monedas de 2 euros <br/>';
            }else if (this.coins.twoEuros === JSON.parse(this.lastSummary.close_details).twoEuros){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).twoEuros - this.coins.twoEuros ) +  ' ' + 'monedas de 2 euros <br/>';  
                    }
            if(this.coins.fiveEuros > JSON.parse(this.lastSummary.close_details).fiveEuros){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.fiveEuros - JSON.parse(this.lastSummary.close_details).fiveEuros ) +  ' ' + 'billetes de 5 euros <br/>';
            }else if (this.coins.fiveEuros === JSON.parse(this.lastSummary.close_details).fiveEuros){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).fiveEuros - this.coins.fiveEuros ) +  ' ' + 'billetes de 5 euros <br/>';
                    }
            if(this.coins.tenEuros > JSON.parse(this.lastSummary.close_details).tenEuros){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.tenEuros - JSON.parse(this.lastSummary.close_details).tenEuros ) +  ' ' + 'billetes de 10 euros <br/>';
            }else if (this.coins.tenEuros === JSON.parse(this.lastSummary.close_details).tenEuros){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).tenEuros - this.coins.tenEuros ) +  ' ' + 'billetes de 10 euros <br/>';
            }
            if(this.coins.twentyEuros > JSON.parse(this.lastSummary.close_details).twentyEuros){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.twentyEuros - JSON.parse(this.lastSummary.close_details).twentyEuros ) +  ' ' + 'billetes de 20 euros <br/>';
            }else if (this.coins.twentyEuros === JSON.parse(this.lastSummary.close_details).twentyEuros){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).twentyEuros - this.coins.twentyEuros ) +  ' ' + 'billetes de 20 euros <br/>';      
            }
            if(this.coins.fiftyEuros > JSON.parse(this.lastSummary.close_details).fiftyEuros){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.fiftyEuros - JSON.parse(this.lastSummary.close_details).fiftyEuros ) +  ' ' + 'billetes de 50 euros <br/>';
            }else if (this.coins.fiftyEuros === JSON.parse(this.lastSummary.close_details).fiftyEuros){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).fiftyEuros - this.coins.fiftyEuros ) +  ' ' + 'billetes de 50 euros <br/>';              
            }
            if(this.coins.hundredEuros > JSON.parse(this.lastSummary.close_details).hundredEuros){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.hundredEuros - JSON.parse(this.lastSummary.close_details).hundredEuros ) +  ' ' + 'billetes de 100 euros <br/>';
            }else if (this.coins.hundredEuros === JSON.parse(this.lastSummary.close_details).hundredEuros){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).hundredEuros - this.coins.hundredEuros ) +  ' ' + 'billetes de 100 euros <br/>';              
            }
            if(this.coins.twoHundredEuros > JSON.parse(this.lastSummary.close_details).twoHundredEuros){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.twoHundredEuros - JSON.parse(this.lastSummary.close_details).twoHundredEuros ) +  ' ' + 'billetes de 200 euros <br/>';
            }else if (this.coins.twoHundredEuros === JSON.parse(this.lastSummary.close_details).twoHundredEuros){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).twoHundredEuros - this.coins.twoHundredEuros ) +  ' ' + 'billetes de 200 euros <br/>';              
            }
            if(this.coins.fiveHundredEuros > JSON.parse(this.lastSummary.close_details).fiveHundredEuros){
                this.textDifferenceClose += 'Te Sobran'+ ' ' + (this.coins.fiveHundredEuros - JSON.parse(this.lastSummary.close_details).fiveHundredEuros ) +  ' ' + 'billetes de 500 euros <br/>';
            }else if (this.coins.fiveHundredEuros === JSON.parse(this.lastSummary.close_details).fiveHundredEuros){
                this.textDifferenceClose += '';
            }else{
                this.textDifferenceClose += 'Te faltan'+ ' ' + ( JSON.parse(this.lastSummary.close_details).fiveHundredEuros - this.coins.fiveHundredEuros ) +  ' ' + 'billetes de 500 euros <br/>';              
            }
            return this.textDifferenceClose
        }else{
            this.textDifferenceClose = '¿Está seguro de realizar la apertura de caja? Existe una diferencia de: '+ this.difference +'€ respecto al último cierre: <br/>';
            return this.textDifferenceClose
        }
    }

    getLastSummary() {
        let params:any = {
            where:{}
        };
        if (this.openSummary){
            params.where.shop = this.shopId;
            params.sort = 'id DESC';
            params.limit = 1;
        }else{
            params.where.shop = this.shopId;
            params.where.createdBy = this.userId;
            params.where['createdAt'] = {}
            params.where['createdAt'][">="] = moment().format("YYYY-MM-DD");
            params.where['createdAt']["<"] = moment().add(1,'days').format("YYYY-MM-DD");
        }
        this.turnSummaryService.query(params).subscribe((result)=>{
            this.lastSummary = result[0];
            if (!this.lastSummary && !this.openSummary){
                this.toastr.error('', 'No se puede realizar un cierre de turno debido a que no hay una apertura de caja hoy para esta tienda y usuario', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
            }
            if (this.openSummary && this.lastSummary.createdBy.id != this.userId && this.lastSummary.close_details == null){
                this.toastr.error('', 'Ya existe una apertura de caja para esta tienda con otro usuario y que no se ha cerrado', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
            }
        });
    }

    initCoins(){
        this.coins = {
            oneCent: 0,
            twoCents: 0,
            fiveCents: 0,
            tenCents: 0,
            twentyCents: 0,
            fiftyCents: 0,
            oneEuro: 0,
            twoEuros: 0,
            fiveEuros: 0,
            tenEuros: 0,
            twentyEuros: 0,
            fiftyEuros: 0,
            hundredEuros: 0,
            twoHundredEuros: 0,
            fiveHundredEuros: 0
        };
    }

    printOpenBox(){
        document.getElementById("OpeningBox").classList.remove('hide');
        window.print();
        document.getElementById("OpeningBox").classList.add('hide');   
    }
    printCloseBox(){
        document.getElementById("CloseBox").classList.remove('hide');
        window.print();
        document.getElementById("CloseBox").classList.add('hide');   
    }
}




// WEBPACK FOOTER //
// ./src/app/tpv/components/tpv/tpv.component.ts